import PropTypes from 'prop-types';
import styled from 'styled-components';

// Relative positioning to correctly position hover action buttons on each chicklet
import { jsx as _jsx } from "react/jsx-runtime";
const Wrapper = styled.div.withConfig({
  displayName: "ChickletWrapper__Wrapper",
  componentId: "sc-52qqrz-0"
})(["position:relative;"]);
const ChickletWrapper = ({
  children,
  seleniumIdentifier,
  seleniumId,
  ariaLabel
}) => {
  return /*#__PURE__*/_jsx(Wrapper, {
    "data-selenium-test": seleniumIdentifier && `${seleniumIdentifier}-chicklet`,
    "data-test-id": seleniumIdentifier && `${seleniumIdentifier}-chicklet`,
    "aria-label": ariaLabel,
    "data-selenium-id": seleniumId,
    children: children
  });
};
ChickletWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  seleniumId: PropTypes.number.isRequired,
  seleniumIdentifier: PropTypes.string
};
export default ChickletWrapper;